import { VtoTypes } from './Vto';

export const VTO_SURVEY_STORAGE_KEY = 'vto.survey';
export const PERLGEM_USER_ID = 'perlgem-user-id';
export const SESSION_ID = 'session-id';

export const surveyTypes = {
    [VtoTypes.FOUNDATION]: 'survey-vto-foundation',
    [VtoTypes.MAKEUP]: 'survey-vto-makeup',
    [VtoTypes.SKINCARE]: 'survey-vto-skincare'
};
